<kSticky stickyId="header" [stickyClass]="'kStickyClass'">
  <div class="kMainMenuWrapper">
    <kLazyModuleLoadingProgressBar></kLazyModuleLoadingProgressBar>
    <div #appmenu class="appMenu">
      <div class="aktru-icon"></div>

      <div #leftMenu class="kMenu-left">
        <div *ngIf="menuID === 'analytics'" class="kAnalytics">
          <div (click)="navigateToDefault()">
            <i class="kIcondropdown_arrow_left"></i>
          </div>
          <i class="k-analytics-logo" (click)="leftMenuConfig[0]?.open()"></i>
        </div>

        <div *ngFor="let item of leftMenuConfig">
          <kMultiAccountMenu
            *ngIf="menuID === 'analytics' && _isMultiAccount && item.customMenuItemId === 'analyticsMultiAccount'"
            style="width: 120px; height: 40px"
            (menuChange)="item.customMenuItemCallback($event)"
            >account</kMultiAccountMenu
          >
          <a
            class="kMenuLink"
            *ngIf="item.menuTitle.length && !item.icon"
            [class.activeLink]="item === selectedMenuItem"
            (click)="item.open()"
          >
            {{ item.menuTitle | uppercase }}
          </a>
        </div>
      </div>

      <div class="kMenu-right">
        <k-logs-record
          mode="button"
          *ngIf="(_kmcLogs.logsRecordMode | async).enabled"
          [logLevel]="(_kmcLogs.logsRecordMode | async).logLevel"
        ></k-logs-record>
        <kUploadButton></kUploadButton>
        <kUploadMonitor [appmenu]="appmenu"></kUploadMonitor>

        <i
          *ngFor="let item of rightMenuConfig"
          (click)="item.open()"
          [ngClass]="item.icon"
          [class.open]="item === selectedMenuItem"
          [kTooltip]="item.menuTitle"
          [placement]="'bottom'"
        ></i>

        <div #username class="kUserName">
          <span>{{ _userAuthentication.appUser?.fullName }}</span>
          <i class="kIcondropdown_arrow_bottom"></i>
        </div>
      </div>
    </div>
  </div>
</kSticky>

<div class="appSubMenu" *ngIf="selectedMenuItem && showSubMenu && selectedMenuItem.children">
  <div class="kContent kSubMenuHolder">
    <kKMCAppContentMenu class="kSubMenu" position="left" [menuItems]="selectedMenuItem.children"></kKMCAppContentMenu>
    <kKMCAppContentMenu class="kSubMenu" position="right" [menuItems]="selectedMenuItem.children"></kKMCAppContentMenu>
  </div>
</div>

<kPopupWidget
  #usersettings
  [appendTo]="appmenu"
  data-aid="usersettings"
  [popupWidth]="240"
  [closeBtn]="false"
  [targetRef]="username"
  [targetOffset]="{ x: 8, y: 30 }"
  (onOpen)="username.className = 'kUserName open'"
  (onClose)="username.className = 'kUserName'"
>
  <kKMCUserSettings [parentPopup]="usersettings"></kKMCUserSettings>
</kPopupWidget>

<kPopupWidget #supportPopup data-aid="supportPopup" [modal]="true" [popupWidth]="500" [popupHeight]="370">
  <ng-template>
    <div class="kHeader">
      <span class="kTitle">{{ 'app.openMail.supportMailTitle' | translate }}</span>
    </div>

    <div class="kContainer">
      <div>{{ 'app.openMail.customerCare' | translate }}</div>
      <a href="{{ _customerCareLink }}" target="_blank">{{ _customerCareLink }}</a>
      <div class="spaceTop">{{ 'app.openMail.customerPortal' | translate }}</div>
      <a href="{{ _customerPortalLink }}" target="_blank">{{ _customerPortalLink }}</a>
    </div>

    <div class="kFooter">
      <button
        type="button"
        class="kButtonBranded"
        (click)="supportPopup.close()"
        pButton
        label="{{ 'app.common.close' | translate }}"
      ></button>
    </div>
  </ng-template>
</kPopupWidget>
